const getters = {
  accounts: (state) =>
    state.accounts.sort((a, b) =>
      a.created_at > b.created_at ? -1 : a.created_at < b.created_at ? 1 : 0
    ), // Ordena por la fecha de creación
  totalAccounts: (state) => state.totalAccounts,
}

export default getters
